module.exports = __webpack_public_path__ + "media/vraag_2_antwoord.11764186.mp3";